import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

class Error500 extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || null };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unexpected error:', error, errorInfo);
  }

  render() {
    const { hasError, errorMessage } = this.state;
    return (
      <ErrorPage
        code={500}
        message={hasError && errorMessage ? errorMessage : undefined}
      />
    );
  }
}

export default Error500;
